import React from "react";
import { buildIdentificador, fechaMX } from "@/lib/format";

const PRINT_CSS = `@media print{@page{size:letter;margin:12mm}body{-webkit-print-color-adjust:exact;print-color-adjust:exact;background:#fff!important}thead{display:table-header-group}tr{page-break-inside:avoid;break-inside:avoid}.avoid-break{page-break-inside:avoid;break-inside:avoid}}.pdf-exporting table td,.pdf-exporting table th{line-height:1.3!important;padding-top:5px!important;padding-bottom:5px!important;vertical-align:middle!important}.pdf-exporting table td{font-size:10.5px!important}.pdf-exporting tr{page-break-inside:avoid;break-inside:avoid}.pdf-exporting .avoid-break{page-break-inside:avoid;break-inside:avoid}`;
const TH = "border border-gray-300 px-2 py-1 align-middle";

export default function DocumentoVenta({ detail, cli, listas = [], printRef, headerRef, bodyRef, titulo = "COTIZACIÓN", numero, fecha, encabezadoExtra, esPedido = false }) {
  const m = (v) => "$" + Number(v || 0).toFixed(2);
  const partidas = detail.partidas || [];
  const subtotalBruto = partidas.reduce((a, p) => a + Number(p.cantidad) * Number(p.precioUnitario || p.precio_unitario || 0), 0);
  const subDesc = Number(detail.subtotal || 0);
  const factor = subtotalBruto > 0 ? subDesc / subtotalBruto : 1;
  const totalKg = partidas.reduce((a, p) => a + (Number(p.peso) || 0), 0);
  const totalAtados = partidas.reduce((a, p) => a + (Number(p.atados) || 0), 0);
  const totalDesc = subDesc - subtotalBruto;
  const listaNombre = listas.find((l) => l.id === cli?.lista_precios)?.name || "";
  const identificador = buildIdentificador({ fecha: detail.fecha, subtotalConDescuento: subDesc, totalKg, listaNombre });
  const descs = detail.descuentos_aplicados || [];
  return (
    <div ref={printRef} className="doc-sheet bg-white text-black px-6 py-6 md:px-8 md:py-8 w-full max-w-[750px] mx-auto box-border" data-testid="documento-venta">
      <style>{PRINT_CSS}</style>
      <div ref={headerRef}>
        <div className="grid grid-cols-[auto_1fr_auto] gap-6 items-start bg-gray-50 px-3 py-3">
          <div className="text-center">
            <img src="/logo-cooper.png" className="h-16 w-16 object-contain rounded-lg mx-auto" alt="Cooper Slip" />
            <div className="text-xs mt-1">Cooper Slip</div>
          </div>
          <div className="text-center text-sm font-bold leading-snug pt-3">
            <p>Cuando tu cliente queda bien, Tu quedas mejor.</p>
            <p>Elije las duelas que respaldan a tu negocio</p>
          </div>
          <div className="text-right">
            <h2 className="text-3xl font-extrabold tracking-tight">{titulo}</h2>
            <p className="text-sm mt-1"><span className="font-bold">No.:</span> {numero ?? detail.cot_no}</p>
            <p className="text-sm"><span className="font-bold">Fecha:</span> {fechaMX(fecha ?? detail.fecha)}</p>
            {encabezadoExtra}
          </div>
        </div>
        <div className="border-t-4 border-black" />
      </div>
      <div ref={bodyRef}>
        <div className="mt-4">
          <h3 className="font-bold text-base mb-1">Datos del Cliente</h3>
          <p className="text-sm"><span className="font-bold">Cliente:</span> {cli?.nombre_razon_social || detail.cliente}</p>
          {cli?.rfc && <p className="text-sm"><span className="font-bold">RFC:</span> {cli.rfc}</p>}
        </div>
        <table className="w-full text-xs border-collapse mt-4">
          <thead>
            <tr className="bg-gray-100">
              <th className={`${TH} text-left`}>N/REF</th>
              <th className={`${TH} text-left`}>Modelos</th>
              <th className={`${TH} text-center`}>Cantidad</th>
              <th className={`${TH} text-center`}>Panel</th>
              <th className={`${TH} text-center`}>Atados</th>
              <th className={`${TH} text-center`}>Peso</th>
              <th className={`${TH} text-right`}>P/U</th>
              <th className={`${TH} text-right`}>C/Descuento</th>
              <th className={`${TH} text-right`}>Total</th>
            </tr>
          </thead>
          <tbody>
            {partidas.map((p, i) => {
              const pu = Number(p.precioUnitario || p.precio_unitario || 0);
              const pc = pu * factor;
              return (
                <tr key={i}>
                  <td className={TH}>{p.nRef || p.numero_referencia || "-"}</td>
                  <td className={TH}>{p.modelo}</td>
                  <td className={`${TH} text-center`}>{p.cantidad}</td>
                  <td className={`${TH} text-center`}>{p.tipo || "Verde"}</td>
                  <td className={`${TH} text-center`}>{p.atados != null ? Number(p.atados).toFixed(1) : "-"}</td>
                  <td className={`${TH} text-center`}>{p.peso ? Number(p.peso).toFixed(2) : "-"}</td>
                  <td className={`${TH} text-right`}>{m(pu)}</td>
                  <td className={`${TH} text-right`}>{m(pc)}</td>
                  <td className={`${TH} text-right font-semibold`}>{m(Number(p.cantidad) * pc)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="flex justify-end mt-5 avoid-break">
          <div className="w-80 text-sm">
            <div className="flex justify-between py-1"><span>Subtotal:</span><span className="font-bold">{m(subtotalBruto)}</span></div>
            {descs.map((d, i) => (
              <div key={i} className="flex justify-between py-1 text-red-600"><span>Descuento por {d.nombre} ({d.valor}%):</span><span></span></div>
            ))}
            <div className="flex justify-between py-1 text-red-600"><span>Total Descuento:</span><span className="font-bold">-{m(Math.abs(totalDesc))}</span></div>
            <div className="border-t border-gray-300 mt-1 pt-1 flex justify-between py-1"><span>Subtotal con Descuento:</span><span className="font-bold">{m(subDesc)}</span></div>
            <div className="flex justify-between py-1"><span>IVA (16%):</span><span className="font-bold">{m(detail.iva)}</span></div>
            <div className="border-t-2 border-black mt-1 pt-2 flex justify-between items-center"><span className="text-blue-600 font-bold text-xl">Total:</span><span className="text-blue-600 font-bold text-xl">{m(detail.total)}</span></div>
          </div>
        </div>
        <p className="text-center italic text-sm mt-6">Con este Importe No solo compras duelas, compras tranquilidad y reputacion frente a tus clientes</p>
        <div className="mt-6 avoid-break">
          <h3 className="font-bold text-sm mb-2">Información Importante:</h3>
          <ul className="list-disc pl-6 text-sm space-y-1">
            <li><span className="font-bold">Identificador:</span> {identificador}</li>
            <li><span className="font-bold">Cantidad total de atados:</span> {totalAtados.toFixed(0)}</li>
            <li><span className="font-bold">Cantidad total de KG:</span> {totalKg.toFixed(2)} kg</li>
            <li><span className="font-bold">Condiciones de pago:</span> {detail.condicion_pago || cli?.condiciones_pago || "-"}</li>
            <li><span className="font-bold">Tiempo de entrega:</span> {cli?.tiempo_entrega || "-"}</li>
            {!esPedido && <li><span className="font-bold">Vigencia de cotización:</span> {detail.vigencia || cli?.vigencia_cotizacion || "-"}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
